import { type ReactElement } from 'react'

import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'

import { GuaranteeListCard } from '../guarantee-list-card/guarantee-list-card.tsx'

const PLACEHOLDER_GROUPS = [0, 1]

/**
 * Pending state for `GuaranteeList`. Shares its card frame and repeats its per-group stack, so the
 * crossfade lands on the same shape.
 */
export function GuaranteeListSkeleton(): ReactElement {
  return (
    <GuaranteeListCard>
      {PLACEHOLDER_GROUPS.map((group) => (
        <div key={group} className="flex flex-col gap-30">
          <Skeleton variant="text" width={180} height={24} />
          {/* Three rows. From `md` a row is 68px: the 36px value column (a 20px value over a 16px
              caption) plus `py-50`. Below `md` the actions wrap under the label, which adds the
              32px media line and the 16px row gap, so a row is 116px. */}
          <Skeleton
            variant="block"
            className="
              h-[348px]
              md:h-[204px]
            "
          />
        </div>
      ))}
    </GuaranteeListCard>
  )
}
